import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=0ee65ee8&"
import script from "./Logos.vue?vue&type=script&lang=js&"
export * from "./Logos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports